import { useNavigate } from 'react-router';

import { useHaptic } from '@/app/TmaProvider';
import { Chip, ChipGroup, MainButton } from '@/components/ui';
import { fmt, texts } from '@/lib/texts';

import { OnboardingScreen, OptionsState, useOptions } from './shared';

const t = texts.onboarding.district;
const MAX_DISTRICTS = 5;

/** Шаг 2 — районы (до 5). */
export function DistrictScreen() {
  return (
    <OnboardingScreen step={2} title={t.title} subtitle={t.subtitle}>
      {({ draft, update }) => {
        return <Body cityId={draft.cityId!} selected={draft.districtIds} update={update} />;
      }}
    </OnboardingScreen>
  );
}

function Body({
  cityId,
  selected,
  update,
}: {
  cityId: string;
  selected: string[];
  update: (p: { districtIds?: string[]; step?: number }) => void;
}) {
  const options = useOptions(cityId);
  const navigate = useNavigate();
  const haptic = useHaptic();
  const districts = options.data?.districts ?? [];
  const full = selected.length >= MAX_DISTRICTS;

  const toggle = (id: string) => {
    haptic.selection();
    if (selected.includes(id)) update({ districtIds: selected.filter((x) => x !== id) });
    else if (!full) update({ districtIds: [...selected, id] });
  };

  return (
    <OptionsState query={options}>
      <ChipGroup>
        {districts.map((d) => (
          <Chip
            key={d.id}
            selected={selected.includes(d.id)}
            disabled={full && !selected.includes(d.id)}
            onClick={() => toggle(d.id)}
          >
            {d.name}
          </Chip>
        ))}
      </ChipGroup>
      <p className="text-muted px-1 text-sm">
        {selected.length > 0 ? fmt(t.selected, { n: selected.length }) : t.max}
      </p>
      <MainButton
        text={texts.common.next}
        enabled={selected.length > 0}
        onClick={() => {
          update({ step: 2 });
          void navigate('/onboarding/schedule');
        }}
      />
    </OptionsState>
  );
}
